var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonalcart = function SvgPersonalcart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.375,
    d: "M26.917 33.25H11.084c-6.334 0-7.917-1.583-7.917-7.917V12.667c0-6.334 1.583-7.917 7.917-7.917h15.833c6.333 0 7.917 1.583 7.917 7.917v12.666c0 6.334-1.584 7.917-7.917 7.917Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.375,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.166 12.668h7.917M23.749 19h6.333M26.916 25.334h3.167M13.459 17.876a2.866 2.866 0 1 0 0-5.731 2.866 2.866 0 0 0 0 5.731ZM19 25.856a4.782 4.782 0 0 0-4.339-4.306c-.792-.08-1.6-.08-2.407 0-2.295.221-4.116 2.01-4.338 4.306"
  }))));
};
export default SvgPersonalcart;